import React from 'react';
import {
    PlanCurriculumTabContent,
    type PlanCurriculumTabContentProps
} from './PlanCurriculumTabContent';

export type CreateUnitsTabContentProps = Omit<
    PlanCurriculumTabContentProps,
    'isStudentCurriculumActive' | 'noStudentsDescription' | 'showAddCustomMenu'
> & {
    onOpenCreateUnitWizard: () => void;
};

/** Create Units tab — Student curriculum mode, unit creation actions, and Create-specific empty copy. */
export function CreateUnitsTabContent({
    onOpenCreateUnitWizard,
    ...props
}: CreateUnitsTabContentProps) {
    return (
        <PlanCurriculumTabContent
            {...props}
            isStudentCurriculumActive={true}
            showAddCustomMenu={false}
            onOpenCreateUnitWizard={onOpenCreateUnitWizard}
            noStudentsDescription="You need to create a student before you can create units."
        />
    );
}
